import React from 'react';
import {Link} from "react-router-dom";

import styles from './ModalCreatedOrder.module.scss';
import cleaningProcess from '../../constants/images/created-order.svg';
import {MAIN_ROUTES} from "../../routing/main_routes";

const ModalCreatedOrder = () => {
    return (
        <div className={styles.createdOrder_wrapper}>
            <div className={styles.createdOrder_wrapper_createdOrder}>
                <div className={styles.createdOrder_wrapper_createdOrder_description}>
                    <img src={cleaningProcess} alt="cleaning process icon"/>

                    <h2>Ваше замовлення побачили клінери</h2>
                    <p>Не хвилюйтесь, через кілька хвилин ви зможете переглянути список клінерів</p>
                </div>

                <Link to={MAIN_ROUTES.MAIN}>
                    <button className={styles.createdOrder_wrapper_createdOrder_button}>
                        На головну
                    </button>
                </Link>
            </div>
        </div>
    );
};

export default ModalCreatedOrder;